import React from 'react';
import { debounce } from 'lodash-es';
import { IframeIntegration } from 'integrations';
import { IScrollData } from 'interfaces/IScrollData';
import { onElementHeightChange } from 'integrations/utils/onElementHeightChange';

export const useUpdateTopPosition = (
    dynamicHeight: boolean,
    getNewTopPosition: (data: IScrollData) => number,
    elementRef?: React.MutableRefObject<HTMLElement>,
    debounceWait = 400,
): number => {
    const [topPosition, updatePosition] = React.useState(300);

    React.useEffect(() => {
        if (!dynamicHeight) {
            return undefined;
        }
        let elementUpdateHeightSubscribe: ICallback;

        const worker = (data: IScrollData) => {
            const newValue = getNewTopPosition(data);
            updatePosition(newValue);
        };

        if (elementRef?.current) {
            elementUpdateHeightSubscribe = onElementHeightChange(elementRef.current, () => {
                IframeIntegration.getViewPort().then(worker);
            });
        }

        IframeIntegration.getViewPort().then(worker);
        const debounceUpdate = debounce(worker, debounceWait);
        const unsubscribe = IframeIntegration.subscribeScroll(debounceUpdate);

        return () => {
            IframeIntegration.unsubscribeScroll();
            unsubscribe();
            if (elementUpdateHeightSubscribe) {
                elementUpdateHeightSubscribe();
            }
        };
    }, [dynamicHeight, elementRef]);

    return topPosition;
};
